<template>
    <UserPageLayout>
        <div style="margin-bottom: 4rem;">
            <h1 class="text-white text-center text-3xl">Creators</h1>

            <div class="max-w-lg mx-auto text-white">
                <h3>Get credits for creating quiz and questions for TheBigQuiz</h3>

                <p>
                    We looking for people who can help us create quality quizes and questions.
                </p>

                <h3>How to create a quiz for public use</h3>
                <ol>
                    <li>Apply as a Quiz Creator</li>
                    <li>Create a quiz with at least 10 questions</li>
                    <li>Check the box "Submit for approval" at create quiz form</li>
                </ol>

                <p>When you're quiz is approved, you will get credits to you account.</p>

                <h3>Guidelines for approval and credits</h3>
                <ul>
                    <li>Quiz must be in English</li>
                    <li>Quiz/questions must be within one of the categories listed below</li>
                    <li>Questions must be self explaining and be possible to present outside of the context of a specific quiz</li>
                    <li>Question must have maximum 100 characters</li>
                    <li>Choices must have maximum 50 characters</li>
                    <li>Question must be created by you. No other copyright must be apply</li>
                    <li>For each approved question you will get <strong>1 credit</strong></li>
                    <li>Use different types of questions types (text, song, blur image)</li>
                    <li>Use different types of choices, 2-8 choice, 1 or multiple correct etc.</li>
                </ul>

                <div class="mt-12">
                    <div v-if="userRole">
                        <p v-if="userRole == 'creator'" class="text-center font-bold mb-4">{{ userRole == 'creator' ? 'Your are creator' : 'Apply to Creator' }}</p>
                        <div v-if="userRole == 'creator'" class="text-center">
                            <a @click.prevent="clickNewQuiz" class="btn text-lg font-opensans">New Quiz</a>
                        </div>
                        <button v-if="userRole == 'member'" @click="applyToCreator" class="btn btn-block text-lg font-opensans">
                            {{ userRole == 'creator' ? 'Your are creator' : 'Apply to Creator' }}
                        </button>
                        <button v-if="['member', 'creator'].indexOf(userRole) == -1" class="btn btn-block text-lg font-opensans" disabled>Only member can apply to creator</button>
                    </div>
                    <div v-else>
                        <!-- If not logged in -->
                        <button class="btn btn-block text-lg font-opensans" @click="applyToCreator">Apply to Creator</button>
                    </div>
                </div>
            </div>
        </div>
        <AuthPopup
            v-if="showAuthPopup"
            :webview-redirect-to="createWebviewRedirectTo()"
            @login-success="loginSuccess"
            @register-success="loginSuccess"
            @close="showAuthPopup = false" />
    </UserPageLayout>
</template>

<script>

import popup from '@/lib/popup'
import { currentUser, isLoggedIn } from '@/lib/user'
import UserPageLayout from '@/layouts/UserPage'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'

export default {
    components: {
        UserPageLayout,
        AuthPopup
    },

    mixins: [
        AuthPopupMixin
    ],

    mounted () {
        document.body.style.overflow = 'auto'
    },

    data () {
        return {
            userRole: currentUser().role
        }
    },

    methods: {

        afterLoginSuccess () {
            this.userRole = currentUser().role
        },

        clickNewQuiz () {
            window.location.href = this.$router.resolve({name: 'setting'}).href
        },

        applyToCreator() {

            if (!isLoggedIn()) {
                this.showAuthPopup = true

                return
            }

            this.$store.commit('toggleMainLoader', true)
            this.$store.dispatch('applyToCreator')
                .then(() => {
                    this.$store.dispatch('refreshToken')
                        .then(() => {
                            this.$store.commit('toggleMainLoader', false)
                            popup.alert("Thank you! \n You are now activated as a quiz creator for TheBigQuiz. \n You can now start creating and submit for approval", () => {}, {
                                icon: 'success'
                            })

                            this.userRole = currentUser().role
                        })
                })
                .catch((e) => {
                    if (e) {
                        popup.alert('Apply to quiz creator fail', () => {}, {
                            icon: 'error'
                        })

                        this.$store.commit('toggleMainLoader', false)
                    }
                })
        }
    }
}
</script>
